const newComparisonMessages = {
  pageTitles: {
    title: 'New Comparison',
    subTitle: '',
  },
  cardTitles: {
    card1: {
      title: 'Comparison Details',
    },
    card2: {
      title: 'Comparison Parameters',
      subTitle: 'Select the parameters and Sub Parameters you want to compare',
    },
  },
  buttons: {},
};

export default newComparisonMessages;
